import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Booking from './Booking';

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  booking: Booking,
});

export default reducers;
